<template>
  <div class="block-wallet d-flex align-center justify-space-between">
    <div class="block-wallet__left">
        <img :src="icon" class="icon" />
        <div class="block-wallet__left-text">{{ title }}</div>
    </div>
    <div class=' block-wallet__right'>
      <slot/>
    </div>
  </div>
</template>
<script>
export default {
  name: 'BlockWallet',
  props: {
    title: {
      type: String,
      default: () => 'Metamask',
    },
    icon: {
      type: String,
      default: () => require('@/assets/icons/icon-fox.svg'),
    },
  },
  data() {
    return {

    }
  }
}
</script>
<style lang='scss'>
@import '@/sass/variable.scss';

.block-wallet {
    padding: 8px;
    border-radius: 8px;
    background-color: rgba(61, 111, 212, 0.05);

    .icon {
        width: 24px;
        height: 24px;
    }

    &__left {
        display: flex;
        align-items: center;
        gap: 5px;
    }

    &__right {
        min-height: 35px;
        display: flex;
        align-items: center;
        button {
            margin-top: 0 !important;
        }
    }

    &__left-text {
        font-weight: bold;

    }

    @media only screen and (max-width: $screen_sm) {
        .space-mobile {
            margin: 0 0px -8px 0px !important;
        }
    }
}
</style>
